import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

const breadcrumbMap: Record<string, string> = {
  users: 'Users',
  'user-details': 'User Details',
  'user-summary': 'User Summary',
  'audit-report': 'Audit Report',
  'error-logs': 'Error Logs',
  'application-settings': 'Settings',
  'application-permissions': 'Permissions',
  programs: 'Programs',
  'role-templates': 'Role Templates',
  'business-hours': 'Business Hours',
  configuration: 'Configuration',
  'holiday-calendars': 'Holiday Calendars',
  'master-data': 'Master Data',
  'instruction-manager': 'Instruction Manager',
  'job-monitor': 'Job Monitor',
  'platform-ops': 'Platform Ops',
  'system-alerts': 'System Alerts',
  'system-health': 'System Health',
  'email-templates': 'Email Templates',
  'environment-config': 'Environment Config',
  'feature-flags': 'Feature Flags',
  'legal-pages': 'Legal Pages',
  'release-management': 'Release Management',
  'tenant-management': 'Tenant Management',
  'login-page-settings': 'Login Page Settings',
  'ui-settings': 'UI Settings',
  dashboard: 'Dashboard',
};

type Props = {
  title: string;
  description?: string;
  actions?: ReactNode;
};

export function AdminPageHeader({ title, description, actions }: Props) {
  const { pathname } = useLocation();

  const crumbs = pathname
    .split('/')
    .filter(Boolean)
    .slice(1) // skip "superadmin"
    .map((seg) => breadcrumbMap[seg] || seg.replace(/-/g, ' '));

  return (
    <div className="space-y-2">
      {/* Breadcrumb */}
      <div className="text-xs text-muted-foreground">
        Superadmin{crumbs.length > 0 ? ` / ${crumbs.join(' / ')}` : ''}
      </div>

      {/* Header */}
      <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <div>
          <h1 className="text-page-title app-page-title text-foreground">{title}</h1>
          {description && (
            <p className="text-sub-header text-muted-foreground">{description}</p>
          )}
        </div>

        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
